export default {
  project: 'Projeto',
  project_license: 'Projeto + Licença',
  recurring: 'Recorrente',
  license: 'Licença',
  subscription: 'Assinatura',
  hourly: 'Hora',
  other: 'Outro',
  options: [
    { value: 'project', text: 'Projeto' },
    { value: 'project_license', text: 'Projeto + Licença' },
    { value: 'recurring', text: 'Recorrente' },
    { value: 'license', text: 'Licença' },
    { value: 'subscription', text: 'Assinatura' },
    { value: 'hourly', text: 'Hora' },
    { value: 'other', text: 'Outro' }
  ]
};
